const ListItemERA=(props)=>{
	let className=props.item.status=='Open' ? 'open' : 'close';
	className=className+"-btn";
	return (
		<>


		<div className="gridItem">
          <div className="gridItemHeading"><span>{props.item.program_title}</span></div>
          <div className="gridContent">
            <div><strong>Program Type: </strong><span>{props.item.program_type}</span></div>
            <div><strong>Details: </strong><span>Offers emergency rental assistance, covid relief, utility assistance and more</span></div>
          </div>
          <div style={{textAlign:'right', paddingTop:'60px',paddingRight:'20px',height:'200px',backgroundImage:'url(/img/map2.png)',backgroundSize:'contain'}}>
            <a href={props.item.program_link} style={{fontWeight:'normal',textDecoration:'none'}} className="open-btn">Apply Now</a>
          </div>
        </div>



		</>
		)
};
export default ListItemERA; 